










































import draggable from 'vuedraggable';
import { Component, Vue } from 'vue-property-decorator';
import Teacher from '@/services/Teacher';
import { Teacher as ITeacher } from '@/models/Teachers';
import { IClass } from '@/models/Classes';
import Classroom from '@/services/Classroom';

@Component({
  components: {
    draggable,
  },
})
export default class Dashboard extends Vue {
  classrooms: any[] = [];
  sortedClassrooms: any[] = [];
  teacher: ITeacher | null = null;

  async mounted() {
    this.teacher = await Teacher.getLoggedInTeacher();
    if (!this.teacher) {
      return;
    }

    const observer = await Classroom.getClassroomsObserver();
    if (observer) {
      observer.onSnapshot(async snapshot => {
        const classrooms = !snapshot.empty
          ? snapshot.docs.map(doc => {
              return { uuid: doc.id, ...doc.data() };
            })
          : [];

        this.classrooms = classrooms;
        // re-get the teacher to get the latest classrooms list
        this.teacher = await Teacher.getLoggedInTeacher();

        if (this.teacher?.classrooms) {
          this.sortedClassrooms = this.teacher?.classrooms.reduce((all, cId) => {
            const classroom = this.classrooms.find(c => c.uuid === cId);
            if (classroom) {
              all.push(classroom);
            }
            return all;
          }, [] as IClass[]);
        } else {
          this.sortedClassrooms = this.classrooms;
        }
      });
    }
  }

  createClassroom() {
    this.$parent.$emit('create-classroom');
  }

  updateClassroomOrder() {
    if (!this.teacher) {
      return;
    }

    const classroomIds = this.sortedClassrooms.map(c => c.uuid) as string[];
    Teacher.updateClassroomOrder(this.teacher.id, classroomIds);
  }
}
